import type { WalkthroughConfig } from "../types";

export const websiteWalkthrough: WalkthroughConfig = {
  id: "page-website",
  title: "Website & Funnels",
  description: "Build your public website and conversion funnels.",
  type: "page",
  pageRoute: "/website",
  duration: "1 min",
  category: "pages",
  icon: "Globe",
  steps: [
    {
      id: "intro",
      title: "Website Builder",
      description: "Create your organization's public website with the drag-and-drop builder. Showcase events, member directory, blog, and resources.",
      placement: "center",
      animation: "fade",
      icon: "Globe",
    },
    {
      id: "funnels",
      title: "Campaign Funnels",
      description: "Build targeted landing pages and conversion funnels for membership drives, event registration, and sponsorship acquisition.",
      placement: "center",
      animation: "slide-up",
      icon: "Route",
    },
    {
      id: "seo",
      title: "SEO & Analytics",
      description: "Optimize for search engines, track visitor behavior, and measure conversion rates to grow your online presence.",
      placement: "center",
      animation: "scale",
      icon: "TrendingUp",
      nextLabel: "Got it! ✓",
    },
  ],
};
